import script from "./WetteView.vue?vue&type=script&setup=true&lang=js"
export * from "./WetteView.vue?vue&type=script&setup=true&lang=js"

import "./WetteView.vue?vue&type=style&index=0&id=276547a5&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-276547a5"]])

export default __exports__